import { required } from "vuelidate/lib/validators";

export default class AssinaturaData {
  status = null;
  data_validade = null;
  data_pagamento = null;
  motivo_bloqueio = null;
  valor = null;
  id_plan = null;
  plano = null;
  id_assinatura = null;
  id_empresa = null;
  cnpj_cpf = null;
  plugin_tef = false;
  plugin_certificado = false;
  assinatura_diferenciada = false;
  constructor({
    status = null,
    data_validade = null,
    data_pagamento = null,
    motivo_bloqueio = null,
    valor = null,
    id_plan = null,
    plano = null,
    id_assinatura = null,
    id_empresa = null,
    cnpj_cpf = null,
    plugin_tef = false,
    plugin_certificado = false,
    assinatura_diferenciada = false
  }) {
    this.status = status;
    this.data_validade = data_validade;
    this.data_pagamento = data_pagamento;
    this.motivo_bloqueio = motivo_bloqueio;
    this.valor = valor;
    this.id_plan = id_plan;
    this.plano = plano;
    this.id_assinatura = id_assinatura;
    this.id_empresa = id_empresa;
    this.cnpj_cpf = cnpj_cpf;
    this.plugin_tef= plugin_tef;
    this.plugin_certificado = plugin_certificado;
    this.assinatura_diferenciada = assinatura_diferenciada;
  }
}

export const AssinaturaDataRequired = {
  status: {
    required,
  },
};
